import React, {useMemo} from "react";
import PropTypes from "prop-types";
import EditableFormattedNumberInput from "./document-body-editable-number-input";

const DocumentBodyUnitPriceCell = ({value, onCommit, symbol, isEditable}) => {
    const formattedValue = useMemo(() => {
        const numericValue = Number(value);
        if (Number.isFinite(numericValue)) {
            return numericValue.toLocaleString(undefined, {minimumFractionDigits: 2, maximumFractionDigits: 2});
        }
        return value ?? "";
    }, [value]);

    return (
        <div className="w-full">
            {isEditable ? (
                <EditableFormattedNumberInput
                    value={value}
                    onCommit={onCommit}
                    decimalScale={2}
                    suffix={symbol ? ` ${symbol}` : ""}
                    isEditable
                    allowNegative
                />
            ) : (
                <div className="text-right">
                    <span className="block truncate text-sm text-gray-900">
                        {formattedValue}
                        {symbol ? ` ${symbol}` : ""}
                    </span>
                </div>
            )}
        </div>
    );
};

DocumentBodyUnitPriceCell.propTypes = {
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    onCommit: PropTypes.func,
    symbol: PropTypes.string,
    isEditable: PropTypes.bool,
};

DocumentBodyUnitPriceCell.defaultProps = {
    value: "",
    onCommit: undefined,
    symbol: "",
    isEditable: true,
};

export default DocumentBodyUnitPriceCell;
